import React, { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

import reduceChildRoutes from './reduceChildRoutes';
import { NavItemOption } from './types';

const SidebarNavList = (props: {
  pages: NavItemOption[];
  depth: number;
  collapsed?: boolean;
}) => {
  const { pages, depth, collapsed = false } = props;
  const router = useLocation();
  const currentRoute = router.pathname;

  const childRoutes = pages.reduce(
    (items: ReactNode[], page: NavItemOption) =>
      reduceChildRoutes({ items, page, currentRoute, depth, collapsed }),
    [],
  );
  return <React.Fragment>{childRoutes}</React.Fragment>;
};

export default SidebarNavList;
